<template>
  <!-- Alert Logout Modal -->
  <div
    class="modal fade done"
    id="alertModal"
    aria-hidden="true"
    aria-labelledby="exampleModalToggleLabel2"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <button
          type="button"
          class="close-model-btn"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <i class="fa-regular fa-circle-xmark"></i>
        </button>

        <div class="content-model-me">
          <div class="modal-header">
            <h2 class="section-title">هل تود بالفعل تسجيل خروج؟</h2>
          </div>

          <div class="modal-body">
            <div class="logout-anim-wrap" aria-hidden="true">
              <div class="logout-ring ring-one"></div>
              <div class="logout-ring ring-two"></div>
              <div class="logout-core">
                <div class="logout-door">
                  <span class="door-panel"></span>
                </div>
                <i class="fa-solid fa-right-from-bracket logout-icon"></i>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              class="main-btn red md up"
              :disabled="disabled"
              type="button"
              @click.prevent="signOut()"
            >
              نعم
               <div class="spinner-border" role="status" v-if="disabled">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </button>
            <button
              class="main-btn md up"
              type="submit"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              لا
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--logout modal-->
</template>

<script>
import { defineComponent } from "vue";
import axios from 'axios'
import { fullLogoutWipe } from "../../utils/defaults";

export default defineComponent({
  name: "removeAccountModal",
  data() {
    return {
        disabled : false
    };
  },
  methods: {
    async signOut(){
      const fd = new FormData();
      this.disabled = true;
      let ok = false;
      try {
        const res = await axios.post('sign-out', fd, {
          headers: { 'Authorization':  `Bearer ${sessionStorage.getItem('token')}` }
        });
        ok = (res && res.data && res.data.key === 'success');
      } catch (e) {
        ok = false;
      } finally {
        fullLogoutWipe(axios);

        try {
          document.querySelectorAll('.modal-backdrop').forEach(el => { el.classList.remove('show'); el.style.display = 'none'; });
          const body = document.body;
          body.classList.remove('modal-open');
          body.style.paddingRight = '';
          const alertModal = document.getElementById('alertModal');
          if (alertModal) { alertModal.classList.remove('show'); alertModal.style.display = 'none'; alertModal.setAttribute('aria-hidden','true'); }
          const app = document.getElementById('app');
          if (app && app.hasAttribute('aria-hidden')) app.removeAttribute('aria-hidden');
        } catch (_) { void 0; }

        if (this.$swal) {
          this.$swal({ icon: ok ? 'success' : 'info', title: 'تم تسجيل الخروج', timer: 1200, showConfirmButton: false });
        }

        setTimeout(() => {
          this.$router.push('/').catch(()=>{});
          location.reload();
        }, 900);

        this.disabled = false;
      }
    }
  },

  components: {},
});
</script>
<style scoped>
.logout-anim-wrap {
  position: relative;
  width: 160px;
  height: 160px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logout-ring {
  position: absolute;
  inset: 0;
  border-radius: 18px;
  border: 2px solid rgba(59, 130, 246, 0.18);
  background: rgba(219, 234, 254, 0.92);
  animation: logoutPulse 2.3s ease-out infinite;
}

.ring-two {
  animation-delay: 0.85s;
}

.logout-core {
  position: relative;
  width: 98px;
  height: 98px;
  border-radius: 16px;
  background: rgb(77, 170, 221);
  box-shadow: 0 16px 34px rgba(77, 170, 221, 0.28);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.logout-door {
  position: absolute;
  right: 24px;
  width: 22px;
  height: 42px;
  border: 2px solid rgba(255, 255, 255, 0.82);
  border-radius: 5px;
  opacity: 0.92;
  transform-origin: right center;
}

.door-panel {
  position: absolute;
  top: 16px;
  right: 4px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
}

.logout-icon {
  position: absolute;
  right: 18px;
  top: 50%;
  transform: translateY(-50%);
  color: #dc2626;
  font-size: 34px;
  filter: drop-shadow(0 4px 10px rgba(220, 38, 38, 0.35));
}

@keyframes logoutPulse {
  0% {
    transform: scale(0.74);
    opacity: 0.78;
  }
  70% {
    transform: scale(1.18);
    opacity: 0;
  }
  100% {
    transform: scale(1.18);
    opacity: 0;
  }
}
</style>
